module.exports = __webpack_public_path__ + "img/office.5c0f9cc1.png";